module.exports = __webpack_public_path__ + "img/Payment_Schedule.66422aa0.svg";